import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from 'environment/SsoConfig';
import React, { useEffect, useState } from 'react';

interface MsalProps {
  LoadingScreen: React.ComponentType;
  children: React.ReactNode;
}

const msalInstance = new PublicClientApplication(msalConfig);

const Msal = ({ children, LoadingScreen }: MsalProps) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initializeMsal = async () => {
      try {
        await msalInstance.initialize();
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    initializeMsal();
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
};

export default Msal;
